// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__9a3Ys","spin":"Spinner_spin__0MN__"};